/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.js';
import hi from './locales/hi.js';
import kn from './locales/kn.js';
import ml from './locales/ml.js';
import ta from './locales/ta.js';
import te from './locales/te.js';

/**
 * Phase-1 languages: English, Tamil, Hindi, Telugu, Kannada, Malayalam.
 * Additional locales plug in here via a translation drop — no code change needed.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ta: { translation: ta },
      hi: { translation: hi },
      te: { translation: te },
      kn: { translation: kn },
      ml: { translation: ml },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ta', 'hi', 'te', 'kn', 'ml'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'therapy.lang',
    },
  });

export { i18n };
